import scrollMonitor from 'scrollmonitor';
import pubsub from '../Services/pubsub';

export function publishEnterViewportForElement(element, data) {
    var elementWatcher = scrollMonitor.create(element);

    elementWatcher.one('enterViewport', () => {
        pubsub.publish(pubsub.EVENT_VIEWED_ELEMENT, {
            name: element.id,
            data: data || {},
        });
    });
}

export function add(element) {
    return scrollMonitor.create(element);
}
